<ng-container *ngIf="fieldType === 'text'">
  <ciao-form-field
    class="dense green-grid-theme"
    [label]="placeholder ?? '...'"
    [placeholder]="placeholder ?? ''"
    [agGridContext]="true"
    [formControlInput]="fieldControl"
  >
  </ciao-form-field>
</ng-container>

<ng-container *ngIf="fieldType === 'dropdown'">
  <ciao-form-field
    class="dense green-grid-theme"
    [type]="fieldType"
    [label]="placeholder ?? '...'"
    [placeholder]="placeholder ?? ''"
    [agGridContext]="true"
    [formControlInput]="fieldControl"
    [selectOptions$]="options$"
  >
  </ciao-form-field>
</ng-container>

<ng-container *ngIf="fieldType === 'combobox'">
  <ciao-form-field
    class="dense green-grid-theme"
    [type]="fieldType"
    [label]="placeholder ?? '...'"
    [placeholder]="placeholder ?? ''"
    [agGridContext]="true"
    [formControlInput]="fieldControl"
    [selectOptions$]="options$"
    [compareWith]="compareOptionForSelect"
  >
  </ciao-form-field>
</ng-container>

<ng-container *ngIf="fieldType === 'satPhoneNumber'">
  <ciao-form-field
    class="dense green-grid-theme"
    [type]="fieldType"
    [label]="placeholder ?? '...'"
    [placeholder]="placeholder ?? ''"
    [agGridContext]="true"
    [formControlInput]="fieldControl"
  >
  </ciao-form-field>
</ng-container>

<ng-container *ngIf="fieldType === 'number'">
  <ciao-form-field
    class="dense green-grid-theme"
    [type]="fieldType"
    [label]="placeholder ?? '...'"
    [placeholder]="placeholder ?? ''"
    [agGridContext]="true"
    [formControlInput]="fieldControl"
  >
  </ciao-form-field>
</ng-container>

<ng-container *ngIf="fieldType === 'datetime'">
  <ciao-form-field
    class="dense green-grid-theme"
    [type]="fieldType"
    [label]="placeholder ?? '...'"
    [placeholder]="placeholder ?? ''"
    [agGridContext]="true"
    [formControlInput]="fieldControl"
  >
  </ciao-form-field>
</ng-container>
